<template>
	<section v-loading="loading">
		<el-breadcrumb separator="/" class="breadcrumb">
			<el-breadcrumb-item :to="{ path: '/setting/customer' }">{{ $t("customerProduct.myClient") }}</el-breadcrumb-item>
			<el-breadcrumb-item>{{ $t("customerProduct.productSettings") }}</el-breadcrumb-item>
		</el-breadcrumb>
		<el-tabs v-model="tabsName" type="card" @tab-click="handleTabClick">
			<el-tab-pane :label="$t('common.history')" :name="TabName.HISTORY">
				<ProductHistory
					:productCount="productCount"
					:historyProducts="historyProducts"
					:attributeOptions="attributeOptions"
					@handle-confirm-product-edit="handleConfirmProductEdit"
					@handle-update-specification="handleHistoryUpdateSpecification"
				/>
			</el-tab-pane>
			<el-tab-pane :label="$t('common.all')" :name="TabName.ALL"
				><ProductAll
					:allProducts="allProducts"
					:productCount="productCount"
					:attributeOptions="attributeOptions"
					:meta="meta"
					@handle-current-change="handleCurrentChange"
					@handle-search="handleSearch"
					@handle-confirm-product-edit="handleConfirmProductEdit"
					@handle-update-specification="handleAllUpdateSpecification"
			/></el-tab-pane>
			<el-tab-pane :label="this.$t('customerProduct.specification')" :name="TabName.SPECIFICATION"
				><ProductSpecification :sepcifications="sepcifications" @handle-update-specification="handleUpdateSpecification" />
			</el-tab-pane>
		</el-tabs>
	</section>
</template>

<script>
import ProductAll from "./components/product-all.vue";
import ProductHistory from "./components/product-history.vue";
import ProductSpecification from "./components/product-specification.vue";
import {
	getCustomerPorduct,
	getCustomerPorductLastestCount,
	editCustomerProduct,
	getCustomerHistoryPorduct,
	getCustomerAttributes,
} from "@/services/api-v2/api-v2";
import { debounce } from "lodash";

const TabName = {
	ALL: "all",
	HISTORY: "history",
	SPECIFICATION: "specification",
};

export default {
	name: "customerProduct",

	components: {
		ProductAll,
		ProductHistory,
		ProductSpecification,
	},

	data() {
		return {
			// 客户id
			customerId: "",

			// 加载动画
			loading: false,

			// tabs选项
			tabsName: TabName.HISTORY,

			// allProducts数据
			allProducts: [],

			// historyProducts数据
			historyProducts: [],

			// allProducts分页数据
			meta: {},

			// 当前页面
			currentPage: 1,

			// allProducts搜索关键词
			keyword: "",

			//规格数据
			attributeOptions: [],

			// 编辑规格数据
			editProductDialogForm: {},

			// 规格数据
			sepcifications: [],

			// productCount数量
			productCount: 0,

			TabName,
		};
	},

	created() {
		this.customerId = this.$route.params.id;
		this.initPorductLastestCount();
		this.initHistoryProduct();
	},

	methods: {
		// tabs选项卡事件
		handleTabClick(tab) {
			switch (tab.name) {
				case TabName.ALL:
					this.initAllProduct();
					break;
				case TabName.HISTORY:
					this.initHistoryProduct();
					break;
				case TabName.SPECIFICATION:
					this.initSpecification();
					break;
			}
		},

		// 物料变动维护数量
		async initPorductLastestCount() {
			const { data: result } = await getCustomerPorductLastestCount(this.customerId, 0);
			this.productCount = result.count;
		},

		// 初始化allProduct
		async initAllProduct() {
			this.loading = true;
			try {
				const { data, meta } = await getCustomerPorduct(this.customerId, this.currentPage, this.keyword);
				this.allProducts = data.products;
				this.meta = meta;
				this.attributeOptions = data.attribute_options;
			} catch (error) {
				this.$message.error(error); // 弹出错误提示
			} finally {
				this.loading = false;
			}
		},

		// 初始化productHistory
		async initHistoryProduct() {
			this.loading = true;
			try {
				const { data } = await getCustomerHistoryPorduct(this.customerId);
				this.historyProducts = data.products;
				this.attributeOptions = data.attribute_options;
			} catch (error) {
				this.$message.error(error); // 弹出错误提示
			} finally {
				this.loading = false;
			}
		},

		// 初始化specification
		async initSpecification() {
			try {
				this.loading = true;
				const { data } = await getCustomerAttributes(this.customerId);
				this.sepcifications = data;
			} catch (error) {
				this.$message.error(error); // 弹出错误提示
			} finally {
				this.loading = false;
			}
		},

		// 点击所有商品分页页码事件
		handleCurrentChange(currentPage) {
			this.currentPage = currentPage;
			this.initAllProduct();
		},

		// 所有商品页面搜索数据事件
		handleSearch: debounce(function (keyword) {
			this.keyword = keyword;
			this.currentPage = 1;
			this.initAllProduct();
		}, 500),

		// 确认编辑商品信息
		async handleConfirmProductEdit(data) {
			try {
				await editCustomerProduct(this.customerId, data.productId, data.alias, data.status, data.attributeOptions);
				await this.initAllProduct();
				await this.initHistoryProduct();
				this.$message.success(this.$t("customerProduct.editedSuccessfully"));
			} catch (error) {
				this.$message.error(error);
			}
		},
		// 更新history数据
		handleHistoryUpdateSpecification() {
			this.initHistoryProduct();
		},

		// 更新all数据
		handleAllUpdateSpecification() {
			this.initAllProduct();
		},

		// 更新规格列表
		handleUpdateSpecification() {
			this.initSpecification();
		},
	},
};
</script>

<style scoped>
.breadcrumb {
	margin-bottom: 20px;
}
.el-input.is-disabled /deep/ .el-input__inner {
	color: black;
}
</style>
